<template>
  <div style="padding: 20px 0px 0px 20px;">

    <div>
      <el-button type="primary" size="small" style="float: right;margin-right: 20px;" @click="handleViews('add')">创建新问卷</el-button>
    </div>


    <el-row style="margin-top: 40px;">
      <el-col :span="7" style="margin-right: 10px;" v-for="(itme,index) in dataQuestionnaireList" :key="index">
        <el-card class="box-card">
          <h4>{{ itme.title }}</h4>
          <p style="height: 60px;">{{ itme.describe }}</p>
          <div style="display: flex;justify-content: space-evenly;color: #2d97e4;">
            <div @click="handleView('预览',itme)">
              <i class="el-icon-view"></i>
              <span>预览</span>
            </div>
            <div @click="handleViews('edit',itme)">
              <i class="el-icon-edit"></i>
              <span>编辑</span>
            </div>
            <div @click="handleView('关联链接',itme)">
              <i class="el-icon-share"></i>
              <span>关联链接</span>
            </div>
            <div @click="handleViews('delete',itme)">
              <i class="el-icon-delete"></i>
              <span>删除</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    


    <el-drawer title="预览问卷" :append-to-body="true"  :before-close="handleCloseNode"  :visible.sync="innerNodeDrawer" size="30%">


      <div style="width: 97%; margin-left: 7px; pointer-events: none;" >

        <div  v-for="(item,index) in dataList" :key="index" class="no_click">

            <div  v-if="item.tepy === 1" style="margin-top: 40rpx; padding-left: 5%;">
              <span  style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.{{ item.text }}</span>
              <el-input type="text"  style="margin: 15px 0px;background-color: #f7f8f9;width: 92%; height: 100rpx;margin-left: 3%;border-radius: 10rpx;margin-top: 10rpx;padding-left: 20rpx;"
              :placeholder="item.placeholderText"  v-model="item.input"></el-input>
            </div>


            <div class="" v-if="item.tepy === 2" style="margin-top: 40rpx; padding-left: 5%;">
              <div style=" margin-bottom: 19px;">
                <span style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.</span>
                <span style="border: 1px solid #eca654;color: #f1a951;border-radius: 10rpx;margin: 0rpx 10rpx;padding: 3px 10px;font-size: 10px;">单选题</span>
                <span style="font-size:  14px; color: #9a9696;">{{ item.text }}</span>
              </div>
              <el-button class="checkbuts" style="height: 28px;font-size: 25rpx;margin-left: 20px; margin-bottom: 20px;" size="small"
              :style="{
                backgroundColor: items.activation === 1 ? '#fef3de' : '',
                color: items.activation === 1 ? '#d48a60' : ''
              }"
              v-for="(items,indexs) in item.typeList" :key="indexs">{{ items.name }}</el-button>
            </div>


            <div  v-if="item.tepy === 3" style="margin-top: 40rpx; padding-left: 5%;">
              <div style=" margin-bottom: 19px;">
                <span style="font-size:  14px;color: #9a9696;" >{{ index + 1 }}.</span>
                <span style="border: 1px solid #eca654;color: #f1a951;border-radius: 10rpx;margin: 0rpx 10rpx;padding: 3px 10px;font-size:  10px;">多选题</span>
                <span style="font-size:  14px;color: #9a9696;">{{ item.text }}</span>
              </div>
              <el-button class="checkbuts" style="height: 28px;font-size: 25rpx; margin-left: 20px; margin-bottom: 20px;" size="small"
              :style="{
                backgroundColor: items.activation === 1 ? '#fef3de' : '',
                color: items.activation === 1 ? '#d48a60' : ''
              }"
              v-for="(items,indexs) in item.typeList" :key="indexs"  >{{ items.name }}</el-button>
            </div>


            <div  v-if="item.tepy === 4" style="margin-top: 40rpx; padding-left: 5%;">
              <span  style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.{{ item.text }}</span>
              <el-input style="margin: 15px 0px;background-color: #f7f8f9;width: 92%; height: 100rpx;margin-left: 3%;border-radius: 10rpx;margin-top: 10rpx;padding-left: 20rpx;"
                placeholder="请选择通话日期" v-model="item.valueDate">
              </el-input>
            </div>


            <div v-if="item.tepy === 5" style="margin-top: 40rpx; padding-left: 5%;">
              <span  style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.{{ item.text }}</span>
              <el-input style="margin: 15px 0px;background-color: #f7f8f9;width: 92%; height: 100rpx;margin-left: 3%;border-radius: 10rpx;margin-top: 10rpx;padding-left: 20rpx;"
                placeholder="请选择通话时间" v-model="item.valueTime">
              </el-input>
            </div>


          </div>


      </div>


      </el-drawer>



      <el-dialog  :center="true" :close-on-click-modal="false" title="已关联获客链接" :visible.sync="rejectDialogShow"  @close="rejectDialogShowClr" width="60%">

        <div style="margin-bottom: 15px;width: 100%;display: flex; justify-content: end; padding-right: 7px;">
          <el-input  placeholder="搜索外链名称" v-model="customerLinkName" @input="handleInputCustomerLinkName" clearable> <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
          <div style="margin-bottom: 15px;width: 50%;display: flex; justify-content: end; padding-right: 7px;">
              <el-button type="primary"  size="small" @click="handQuery">创建新获客链接 </el-button>
          </div>
        </div>


        <el-table  :data="tableData" height="500" stripe style="width: 100%;" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
            <el-table-column  prop="customerLinkName" show-overflow-tooltip label="外链名称" ></el-table-column>
            <el-table-column  prop="questionnaireType" show-overflow-tooltip label="问卷名称">
              <template slot-scope="scope">
                  <span v-if="scope.row.questionnaireType === 1">落地陪跑咨询单</span>
                  <span v-if="scope.row.questionnaireType === 2">线上诊断</span>
                  <span v-if="scope.row.questionnaireType === 3">教养课堂沙龙报名</span>
              </template>
            </el-table-column>
            <el-table-column  prop="operatorName" show-overflow-tooltip label="运营人"></el-table-column>
            <el-table-column  label="操作" width="250">
                <template slot-scope="scope">
                  <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(scope.row,'发放链接')">发放链接</span>
                  <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(scope.row,'编辑')">编辑</span>
                </template>
            </el-table-column>
        </el-table>


        <el-pagination
            style="text-align: center;margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            layout="prev, pager, next,sizes,jumper">
        </el-pagination>


      </el-dialog>


      <el-dialog  :center="true" :close-on-click-modal="false" title="添加" :visible.sync="rejectDialogShowADD"  @close="rejectDialogShowClradd" width="40%">
        <div style="display: flex;">
          <span style="width: 80px;padding-top: 10px;">外联名称:</span>
          <el-input style="width: 100%" v-model="input1" placeholder="请输入外联名称"></el-input>
        </div>
        <div style="margin-top: 20px; display: flex;">
          <span style="width: 80px;padding-top: 10px;">选择问卷:</span>
          <el-select placeholder="请选择选择问卷" v-model="input2" style="width: 100%" clearable filterable>
              <el-option   v-for="item in dataQuestionnaireList"  :key="item.id"  :value="item.id" :label="item.titleName"></el-option>
          </el-select>
        </div>
        <div style="margin-top: 20px; display: flex;">
          <span style="width: 80px;padding-top: 10px;">运营人员:</span>
          <el-select placeholder="请选择运营人员" v-model="input3" style="width: 100%" clearable filterable>
              <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
          </el-select>
        </div>

        <div style="text-align: end;margin: 40px 0px 0px 0px;">
          <el-button type="primary"  size="small" @click="handleClr">取消</el-button>
          <el-button type="primary"  size="small" @click="handleSbut">保存</el-button>
        </div>

      </el-dialog>

      <el-dialog  :center="true" :close-on-click-modal="false" title="发放获客链接" :visible.sync="rejectDialogShowADDd"  @close="rejectDialogShowClrADD" width="40%">
        <div>
          <span>外联名称:</span>
          <span style="margin-left: 20px;">{{ openCustomerName ? openCustomerName : '' }}</span>
        </div>
        <div style="margin-top: 20px;">
          <span>外联地址:</span>
          <span style="margin-left: 20px; color: #1098de;" @click="handleClickLink">复制链接</span>
        </div>
        <div style="margin-top: 20px;">
          <span>外联地址:</span>
          <span style="margin-left: 20px; color: #1098de;" @click="handleClickCode">生成二维码</span>
        </div>
      </el-dialog>




      <el-dialog  title="二维码" modal-append-to-body append-to-body  :visible.sync="showQrCodeDialog"   width="50%"  :close-on-click-modal="false" >
        <div style="text-align: center;">
          <img :src="qrCodeUrl" alt="二维码" style="max-width: 100%; height: auto;" />
        </div>
        <div style="text-align: center; margin-top: 20px; text-align: end;">
          <el-button type="primary" @click="showQrCodeDialog = false">关闭</el-button>
        </div>
      </el-dialog>

      <AddQuestionnaireComonmte :titles="titles" :itmes="itmes" @handleColes="handleColes" v-if="is_AddQuestionnaireComonmte"></AddQuestionnaireComonmte>

  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";
import Elupload from "./Elupload";
import { getTeachers,} from "@/api/feedBackApi";
import QRCode from 'qrcode';
import AddQuestionnaireComonmte from "./AddQuestionnaireComonmte.vue";

export default {
  components: { Elupload, AddQuestionnaireComonmte },
  data(){
    return{

      itmes:{},

      customerLinkName:'',
      innerNodeDrawer: false,
      is_AddQuestionnaireComonmte:false,

      dataList:[],
      QuestionnaireViewLsit:[],

      rejectDialogShow:false,
      tableData:[
        {
          weChatName:'1',
          weChatNumber:'1',
          regionName:'1',
        }
      ],

      titles:'',


      pageNum:1,
      pageSize:10,
      total: 10,



      rejectDialogShowADD:false,
      rejectDialogShowADDd:false,


      optionList1:[{realname:'落地陪跑问卷',id:1},{realname:'线上诊断问卷',id:2},{realname:'教养课堂沙龙报名',id:3}],
      optionList2:[],
      input1:'',
      input2:'',
      input3:'',


      dataQuestionnaireList:[
        {
          type:1,
          title:'（咨询单）家庭教育一站式落地陪跑',
          content:'本问卷为关注子女成长与家庭教育的家长们定制，仅用于孩子教育蓝图规划，所有信息进行保密，请您依据家庭实际情况进行填写',
          QuestionnaireViewLsit:[

            {
                text:'属于地域？' ,
                tepy:2 ,
                input:'',
                typeList:[
                    { name: '北京', activation: 1 },
                    { name: '深圳', activation: 0 },
                ],
            },


            {
                text: '怎么称呼您',
                tepy: 1,
                placeholderText: '请输入内容',
                input: '',
                typeList: []
            },

            {
                text: '手机号（请务必保证100%准确，如果通过初审，我们会在12小时内联系您）',
                tepy: 1,
                placeholderText: '请输入内容',
                input: '',
                typeList: []
            },

            {
                text: '您家几个孩子？',
                tepy: 1,
                placeholderText: '请输入内容',
                input: '',
                typeList: []
            },

            {
                text: '您想做教育规划的孩子名字是？',
                tepy: 1,
                placeholderText: '请输入内容',
                input: '',
                typeList: []
            },

            {
                text: '咱们家是男孩还是女孩',
                tepy: 2,
                input: '',
                typeList: [
                    { name: 'A  男孩', activation: 0 },
                    { name: 'B  女孩', activation: 0 },
                ],
            },

            {
                text: '您的孩子目前就读于哪个区哪所学校？',
                tepy: 1,
                placeholderText: '请输入内容',
                input: '',
                typeList: []
            },

            {
                text: '您的孩子目前处于哪个年级？',
                tepy: 3,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '学龄前', activation: 0 },
                    { name: '一年级', activation: 0 },
                    { name: '二年级', activation: 0 },
                    { name: '三年级', activation: 0 },
                    { name: '四年级', activation: 0 },
                    { name: '五年级', activation: 0 },
                    { name: '六年级', activation: 0 },
                    { name: '初一', activation: 0 },
                    { name: '初二', activation: 0 },
                    { name: '初三', activation: 0 },
                    { name: '高一', activation: 0 },
                    { name: '高二', activation: 0 },
                    { name: '高三', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '您希望孩子的哪些科目得到提升？',
                tepy: 3,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '数学', activation: 0 },
                    { name: '语文', activation: 0 },
                    { name: '英语', activation: 0 },
                    { name: '物理', activation: 0 },
                    { name: '化学', activation: 0 },
                    { name: '生物', activation: 0 },
                    { name: '历史', activation: 0 },
                    { name: '地理', activation: 0 },
                    { name: '政治', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '您或孩子之前学过什么课程？',
                tepy: 3,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '家庭教育课程', activation: 0 },
                    { name: '家庭教育博主规划', activation: 0 },
                    { name: '一对一线上补课', activation: 0 },
                    { name: '一对一线下补课', activation: 0 },
                    { name: '大/小班补课', activation: 0 },
                    { name: '兴趣班', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '之前学习课程有哪些效果欠缺的地方？',
                input: '',
                tepy: 3,
                placeholderText: '请选择',
                typeList: [
                    { name: '规划清晰但无法落地', activation: 0 },
                    { name: '大量补课但提分效果微弱', activation: 0 },
                    { name: '依赖课程，一旦停止课程，立马恢复原样', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '您是否注意到孩子在行为或心理上存在以下问题？',
                tepy: 3,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '注意力难以集中', activation: 0 },
                    { name: '情绪波动大，容易焦虑或沮丧', activation: 0 },
                    { name: '抵触学习或拒绝上学', activation: 0 },
                    { name: '社交困难，与同学相处不融洽', activation: 0 },
                    { name: '过度依赖电子产品', activation: 0 },
                    { name: '休学', activation: 0 },
                    { name: '自残', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '您家庭的全年教育支出规划是？',
                input: '',
                tepy: 2,
                placeholderText: '请选择',
                typeList: [
                    { name: '＜10万', activation: 0 },
                    { name: '10-20万', activation: 0 },
                    { name: '20-50万', activation: 0 },
                    { name: '50-100万', activation: 0 },
                    { name: '＞100万', activation: 0 },
                ],
            },

            {
                text: '孩子的一般是谁在带？',
                tepy: 2,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '爸爸', activation: 0 },
                    { name: '妈妈', activation: 0 },
                    { name: '阿姨/保姆', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '您认为家庭氛围如何？',
                tepy: 2,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '非常和谐', activation: 0 },
                    { name: '比较和谐', activation: 0 },
                    { name: '一般', activation: 0 },
                    { name: '偶尔有矛盾', activation: 0 },
                    { name: '经常有矛盾', activation: 0 },
                ],
            },

            {
                text: '您和孩子的关系如何？',
                tepy: 2,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '非常亲密', activation: 0 },
                    { name: '比较亲密', activation: 0 },
                    { name: '一般', activation: 0 },
                    { name: '有些疏远', activation: 0 },
                    { name: '非常疏远', activation: 0 },
                ],
            },

            {
                text: '您希望我们的教育产品能帮助孩子实现哪些目标？',
                tepy: 3,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '提高学习成绩，进入更好的学校', activation: 0 },
                    { name: '激发孩子的兴趣和潜能', activation: 0 },
                    { name: '抵触学习或拒绝上学', activation: 0 },
                    { name: '明确未来的学业、职业发展方向', activation: 0 },
                    { name: '减轻心理压力，变得活泼开朗', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '您作为家长，希望通过我们的产品达到哪些效果？',
                tepy: 3,
                placeholderText: '请选择',
                input: '',
                typeList: [
                    { name: '家庭分工明确，平衡家庭与工作', activation: 0 },
                    { name: '提升自我成长和情绪管理能力', activation: 0 },
                    { name: '加强与孩子的沟通和理解', activation: 0 },
                    { name: '改善家庭氛围和成员关系', activation: 0 },
                    { name: '更好地规划孩子的教育和未来', activation: 0 },
                    { name: '其他', activation: 0 },
                ],
            },

            {
                text: '为什么《家庭教育一站式落地陪跑》应该收录你而不是选择其他申请人？（为保证规划质量与结果，每月只为20人做规划）',
                tepy: 1,
                placeholderText: '请输入内容',
                input: '',
                typeList: []
            },

            {
                text: '如果通过审核，开始为你量身定制《家庭教育一站式落地陪跑》，计划什么时候开始执行和改变？',
                tepy: 2,
                input: '',
                typeList: [
                    { name: '立刻开始', activation: 0 },
                    { name: '1-7天', activation: 0 },
                    { name: '＞7天', activation: 0 },
                ],
            },

            {
                text: '请选择意向通话的日期',
                tepy: 4,
                input: '',
                valueDate: '',
                typeList: []
            },

            {
                text: '请选择意向通话的时间',
                tepy: 5,
                input: '',
                valueTime: '',
                typeList: []
            },
          ]
        },
        {
          type:2,
          title:'学情诊断报告',
          content:'本问卷为关注子女成长与家庭教育的家长们定制，仅用于孩子教育蓝图规划，所有信息进行保密，请您依据家庭实际情况进行填写',
          QuestionnaireViewLsit:[
            {
                text:'属于地域？' ,
                tepy:2 ,
                input:'',
                typeList:[
                    { name: '北京', activation: 1 },
                    { name: '深圳', activation: 0 },
                ],
            },

            {
                text:'你们家是男孩还是女孩？' ,
                tepy:2 ,
                typeList:[
                    { name: 'A  男孩', activation: 0 },
                    { name: 'B  女孩', activation: 0 },
                ],
            },

            {
                text:'孩子名字是什么？' ,
                tepy:1,
                placeholderText:'请输入内容',
                input:'',
                typeList:[]
            },

            {
                text:'目前是几年级？' ,
                tepy:1,
                placeholderText:'五年级',
                input:'',
                typeList:[]
            },

            {
                text:'在哪个学校上学？' ,
                tepy:1,
                placeholderText:'人大附',
                input:'',
                typeList:[]
            },

            {
                text:'一般几点放学？' ,
                tepy:1,
                placeholderText:'5点~7点',
                input:'',
                typeList:[]
            },

            {
                text:'现在都有哪些课外班？' ,
                tepy:1,
                placeholderText:'数学，语文',
                input:'',
                typeList:[]
            },

            {
                text:'周一到周五以及周六日，现在都有什么课程？哪些是文化课？哪些是兴趣班？' ,
                tepy:1,
                placeholderText:'文化课：数学，语文  兴趣班：舞蹈，钢琴',
                input:'',
                typeList:[]
            },

            {
                text:'之前都哪些科补过课，补的都是什么样的课，效果感觉怎么样？' ,
                tepy:1,
                placeholderText:'大班课，数学，效果一般，补课不提分',
                input:'',
                typeList:[]
            },

            {
                text:'最近一次考试情况，成绩班级什么样水平？每科成绩如何？' ,
                tepy:1,
                placeholderText:'班级排名：前10。每科成绩如下：数学：90，语文：80，英语90',
                input:'',
                typeList:[]
            },

            {
                text:'孩子性格是怎么样的？内向还是外向？ 什么星座的？' ,
                tepy:1,
                placeholderText:'外向，比较爱说话，金牛座',
                input:'',
                typeList:[]
            },

            {
                text:'粗不粗心，专注力够不够，爱不爱说话？' ,
                tepy:1,
                placeholderText:'专注力还行，平时爱说话',
                input:'',
                typeList:[]
            },

            {
                text:'打游戏或依赖手机么？' ,
                tepy:1,
                placeholderText:'依赖手机，打游戏，刷视频，姥姥在控制',
                input:'',
                typeList:[]
            },

            {
                text:'您觉得孩子在你眼里是什么样的 您描述一下？' ,
                tepy:1,
                placeholderText:'情商挺高的，对人挺有礼貌的，不犟，听劝，懂事的孩子',
                input:'',
                typeList:[]
            },

            {
                text:'孩子之前有没有经历过休学或者心理疏导？' ,
                tepy:1,
                placeholderText:'经历过休学，进行过心理疏导',
                input:'',
                typeList:[]
            },

            {
                text:'孩子是否会找一些理由请假，不想去学校？' ,
                tepy:1,
                placeholderText:'经常会，理由是……',
                input:'',
                typeList:[]
            },

            {
                text:'孩子在学校的表现，老师是怎么评价的？' ,
                tepy:1,
                placeholderText:'妈妈去开家长会，姥姥不是特别清楚，是班长，人缘好，圆滑',
                input:'',
                typeList:[]
            },

            {
                text:'孩子有没有处对象（初高中）？' ,
                tepy:2 ,
                typeList:[
                    { name: '是', activation: 0 },
                    { name: '否', activation: 0 },
                ],
            },

            {
                text:'孩子跟家长平时沟通是否顺畅？' ,
                tepy:2 ,
                typeList:[
                    { name: '是', activation: 0 },
                    { name: '否', activation: 0 },
                ],
            },

            {
                text:'家长是否学过家庭教育课程？感觉效果怎么样？' ,
                tepy:1,
                placeholderText:'未学过，还不知道效果怎样，没有尝试',
                input:'',
                typeList:[]
            },

            {
                text:'家庭成员都有谁？（父母 二胎 （离异单亲 丧偶）爷爷奶奶 姥姥姥爷 保姆 阿姨 司机 住家家教 ）' ,
                tepy:1,
                placeholderText:'爸爸妈妈都在廊坊，有个姐姐，高三',
                input:'',
                typeList:[]
            },

            {
                text:'平时孩子学习 生活 谁照顾的多一些？' ,
                tepy:1,
                placeholderText:'姥姥照顾生活',
                input:'',
                typeList:[]
            },

            {
                text:'父母都是什么学历背景？' ,
                tepy:1,
                placeholderText:'北京大学，硕士',
                input:'',
                typeList:[]
            },

            {
                text:'你还想告诉诊断老师哪些内容？' ,
                tepy:1,
                placeholderText:'和家里沟通没啥问题，孩子没有自己的目标，规划不清晰，自制性',
                input:'',
                typeList:[]
            },

            {
                text:'平时跟孩子怎么相处的，相处的时间长不长？怎么高质量陪伴孩子的？' ,
                tepy:1,
                placeholderText:'孩子比较听话的，比较懂事',
                input:'',
                typeList:[]
            },

            {
                text:'会不会在孩子面前有争吵？' ,
                tepy:1,
                placeholderText:'有争吵过',
                input:'',
                typeList:[]
            },

            {
                text:'您是怎么评估价自己的（母亲 女儿 工作 生活等方面）' ,
                tepy:1,
                placeholderText:'请输入内容',
                input:'',
                typeList:[]
            },

            {
                text:'教育基金？' ,
                tepy:1,
                placeholderText:'预期教育基金每年在50W',
                input:'',
                typeList:[]
            },

            {
                text:'咱们的教育理念是什么样的？' ,
                tepy:1,
                placeholderText:'请输入内容50W',
                input:'',
                typeList:[]
            },

            {
                text:'找诊断老师诉求有哪些？' ,
                tepy:1,
                placeholderText:'诉求：坚实基础，短期全科提分',
                input:'',
                typeList:[]
            },

            {
                text:'父母都什么工作？忙不忙 弹性吗 压力大吗？上下班时间？' ,
                tepy:1,
                placeholderText:'爸爸妈妈都在廊坊工作，比较忙',
                input:'',
                typeList:[]
            }
          ]
        },
        {
          type:3,
          title:'沙龙报名链接',
          content:'本问卷为教养课堂沙龙报名激发孩子的学习目标和动力，所有信息进行保密，请您依据家庭实际情况进行填写',
          QuestionnaireViewLsit:[
            {
                text:'孩子姓名？' ,
                tepy:1,
                placeholderText:'请输入孩子姓名',
                input:'',
                typeList:[]
            },

            {
                text:'孩子性别？' ,
                tepy:2 ,
                typeList:[
                    { name: 'A  男', activation: 0 },
                    { name: 'B  女', activation: 0 },
                ],
            },

            {
                text:'孩子年龄？' ,
                tepy:1,
                placeholderText:'请输入孩子年龄',
                input:'',
                typeList:[]
            },
            
            {
                text:'请输入您的手机号码：' ,
                tepy:1,
                placeholderText:'请输入手机号码',
                input:'',
                typeList:[]
            },

            {
                text: '透过本次活动想获得那部分的资讯？',
                tepy:1,
                placeholderText:'请输入本次活动想获得那部分的资讯',
                input:'',
                typeList:[]
            },
            
          ]
        },
      ],


      itmeS:{ id:'' },
      openCustomerName:'',
      openCustomerLink:'',
      UrlType:'',


      showQrCodeDialog: false,
      qrCodeUrl: '',
    }
  },

  mounted(){
    axios.get(`${apiBaseUrl}/teacher/teacherSale`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
        this.optionList2  = res.data.data
    })

    this.handleinitList()

  },

  methods:{

    handleinitList(){
        let data = {
          pageNum: 1,
          pageSize: 1000,
        }
        axios.post(`${apiBaseUrl}/questionnaireTemplate/findPage`, data, { headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
        if(res.data.code == 200){
          let data = res.data.data.records || []
          let list = data.map(item => {
            item.describe = item.describeInfo ? item.describeInfo : '暂无描述'
            item.content = item.content ? JSON.parse(item.content) : []
            item.title = item.titleName ? item.titleName : '暂无标题'
            return item
          });
          this.dataQuestionnaireList = list
          }else{
            this.$message.error(res.data.message)
            this.dataQuestionnaireList = []
          }
        }).catch((error)=>{
          this.dataQuestionnaireList = []
          this.$message.error(error)
      })
     
    },

    handleColes(){
      this.is_AddQuestionnaireComonmte = false
      this.handleinitList()
    },

    handleViews(type,itme){

      console.log(itme)

      if(type === 'add'){
        this.itmes = {}
        this.is_AddQuestionnaireComonmte = true
        this.titles = '添加问卷'
      }

      if(type === 'edit'){
        this.itmes = itme
        this.is_AddQuestionnaireComonmte = true
        this.titles = '编辑问卷'
      }

      if(type === 'delete'){
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete(`${apiBaseUrl}/questionnaireTemplate/delete/${itme.id}`, { headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
            if(res.data.code == 200){
              this.$message.success('删除成功')
              this.handleinitList()
            }else{
              this.$message.error(res.data.message)
            }
          }).catch((error)=>{
            this.$message.error(error)
        })
        }).catch(() => {
          this.$message.info('已取消删除')
        });
      }
      
    },

    handleClickCode(){
      
      let openCustomerLink = this.openCustomerLink ? this.openCustomerLink : '';

      if (apiBaseUrl === 'https://ts.mzkt.top/api' || apiBaseUrl === 'https://ts.mzedu.tech/api') {
        openCustomerLink = `https://ceshi.gogocoder.com?linkid=${openCustomerLink}&quesType=${this.UrlType}`;
      }

      if (apiBaseUrl === 'https://www.mzkt.top/api' || apiBaseUrl === 'https://www.mzedu.tech/api') {
        openCustomerLink = `https://wj.mzedu.tech?linkid=${openCustomerLink}&quesType=${this.UrlType}&openCustomerName=${this.openCustomerName}`;
      }

       QRCode.toDataURL(openCustomerLink).then((url) => {
          this.qrCodeUrl = url;
          this.showQrCodeDialog = true;
       }).catch((err) => {
         console.error('二维码生成失败:', err);
         this.$message.error('二维码生成失败');
       })
      

    },



    handleView(enu,itme){
      console.log(enu,itme)

      if(enu === '预览'){
          this.innerNodeDrawer = true
          this.dataList  = itme.content
      }

      if(enu === '关联链接'){

        if(itme.type === 1){
          this.UrlType = 'one'
        }

        if(itme.type === 2){
          this.UrlType = 'two'
        }

        if(itme.type === 3){
          this.UrlType = 'three'
        }

        this.CustomerLinkNameType = itme.type
        this.handleGetApiList()
        this.rejectDialogShow = true
      }

    },

    handleInputCustomerLinkName(){
      this.handleGetApiList()
    },

    handleGetApiList(){

      let date = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        questionnaireType: this.CustomerLinkNameType,
        customerLinkName: this.customerLinkName,
      }
      axios.post(`${apiBaseUrl}/customer_link/findPage`, date ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
        if(res.data.code === 200){
            let data = res.data.data
            if(data){
              this.total = data.total
              this.pageNum = data.current
              this.pageSize = data.size
              this.tableData = data.records.length > 0 ? data.records : []
            }else{
              this.tableData = []
            }
        }else{
            this.$message({ type: 'error', message: '查询失败~' })
        }
      }).catch(err => {
        this.$message({ type: 'error', message: err })
      })
    },


    handleClickDep(itme,type){
      if(type === '发放链接'){
          this.openCustomerName = itme.customerLinkName
          this.openCustomerLink = itme.id
          this.rejectDialogShowADDd = true
      }
      if(type === '编辑'){
          this.itmeS = itme
          this.input1 = itme.customerLinkName
          this.input2 = itme.questionnaireType
          this.input3 = itme.operatorId
          this.rejectDialogShowADD = true
      }

    },

    handleClickLink(){
      let openCustomerLink = this.openCustomerLink ? this.openCustomerLink : ''


      if(apiBaseUrl === 'https://ts.mzkt.top/api' || apiBaseUrl === 'https://ts.mzedu.tech/api'){
          openCustomerLink = `https://ceshi.gogocoder.com?linkid=${openCustomerLink}&quesType=${this.UrlType}`
      }

      if(apiBaseUrl === 'https://www.mzkt.top/api' || apiBaseUrl === 'https://www.mzedu.tech/api'){
          openCustomerLink = `https://wj.mzedu.tech?linkid=${openCustomerLink}&quesType=${this.UrlType}&openCustomerName=${this.openCustomerName}`
      }

      this.$copyText(openCustomerLink).then(() => {
        this.$message.success('复制成功')
      }, () => {
        this.$message.error('复制失败')
      })
    },

    handQuery(){
      this.itmeS.id = ''
      this.rejectDialogShowADD = true
    },

    handleCloseNode(){
      this.innerNodeDrawer = false
    },


    handleClickitmes(e){
      this.dataList = e.questionnaireContent
    },


    rejectDialogShowClr(){
      this.customerLinkName = ''
      this.rejectDialogShow = false
    },



    handleSizeChange(size){
      this.pageSize = size
    },

    handleCurrentChange(size){
      this.pageNum = size
    },



    rejectDialogShowClrADD(){
      this.rejectDialogShowADDd = false
    },
    rejectDialogShowClradd(){
      this.rejectDialogShowADD = false
    },


    handleClr(){
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.rejectDialogShowADD = false
    },

    handleSbut(){

      let date = {
        customerLinkName: this.input1,
        questionnaireType: this.input2,
        operatorId: this.input3,
        id: this.itmeS.id ? this.itmeS.id : ''
      }
      if(this.itmeS.id === '' || this.itmeS.id === undefined || this.itmeS.id === null || this.itmeS.id === 'undefined'){
          axios.post(`${apiBaseUrl}/customer_link/add`, date ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
              if(res.data.code === 200){
                  this.handleClr()
                  this.$message({ type: 'success', message: res.data.message })
                  this.handleGetApiList()
              }else{
                  this.$message({ type: 'error', message: res.data.message })
              }
          }).catch(err => {
            this.$message({ type: 'error', message: err })
          })
      }else{
          axios.post(`${apiBaseUrl}/customer_link/update`, date ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
              if(res.data.code === 200){
                  this.handleClr()
                  this.$message({ type: 'success', message: res.data.message })
                  this.handleGetApiList()
              }else{
                  this.$message({ type: 'error', message: res.data.message })
              }
          }).catch(err => {
            this.$message({ type: 'error', message: err })
          })
      }

    },


  },



}
</script>

<style lang="less" scoped>

.box-card{
  height: 200px;
}





</style>



// WEBPACK FOOTER //
// src/customerManagement/questionnaireManagement.vue